import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconChromecastStyle0 = cosmosIconCss;

const CosmosIconChromecast$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconChromecast extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '483d7a546a80505a21fd7c721ab107a8288bef5d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6970916a2cf8afae7031f4e89e04b229eab2eb45', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ff3dee35680997176d1d8ee316f2cb1389ce11fa', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-5.8a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5h4.8v-11h-16A.5.5 0 0 1 2 5v-.5a.5.5 0 0 1 .5-.5Zm.12 11.4a2.83 2.83 0 0 1 2 2 .49.49 0 0 1-.49.6h-1.6a.51.51 0 0 1-.51-.5v-1.61a.5.5 0 0 1 .6-.49Zm5.31 2.04c-.27-2.865-2.536-5.095-5.4-5.37a.5.5 0 0 0-.53.5v.5a.51.51 0 0 0 .48.5c2.11.224 3.776 1.85 4 3.96a.52.52 0 0 0 .5.47h.5a.49.49 0 0 0 .45-.56Zm-5.44-7.13a.52.52 0 0 1-.49-.5v-.5a.51.51 0 0 1 .54-.5 9.2 9.2 0 0 1 8.67 8.67.51.51 0 0 1-.51.52h-.5a.49.49 0 0 1-.49-.48 7.7 7.7 0 0 0-7.22-7.21Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconChromecastStyle0; }
}, [1, "cosmos-icon-chromecast", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chromecast"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chromecast":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChromecast$1);
            }
            break;
    } });
}

const CosmosIconChromecast = CosmosIconChromecast$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChromecast, defineCustomElement };
